<template>
    <div class="flex justify-between items-start relative z-40">
        <button v-for="{nivel, valor, icone, classeIcone} in niveisCombustivel" :key="valor" class="nivel-combustivel" @click="selecionarNivelBotao(valor)">
            <span class="text-base">{{ nivel }}</span>
            <div class="material-symbols-outlined" :class="classeIcone">{{ icone }}</div>
        </button>
    </div>
</template>

<script>
import NiveisCombustivelConstant from '@/constants/NiveisCombustivelConstant';
import { defineComponent, ref } from 'vue';
export default defineComponent({
    name: 'BotoesNivelCombustivel',
    emits: ['aoSelecionarNivel'],
    methods: {
        selecionarNivelBotao(valor) {
            this.$emit('aoSelecionarNivel', valor);
        }
    },
    setup() {
        const niveisCombustivel = ref(NiveisCombustivelConstant.NIVEIS);
        return { niveisCombustivel }
    }
});
</script>
<style scoped>
.nivel-combustivel {
    @apply flex flex-col justify-center items-center;
}
</style>